module.exports = __webpack_public_path__ + "static/img/passionfruit-m.0813a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/passionfruit-m.jpg
// module id = 8I3e
// module chunks = 0